import React, { useState } from 'react';
import { useForm, } from 'react-hook-form';
import AppSidebar from '../../../components/AppSidebar';
import AppHeader from '../../../components/AppHeader';
import PageHeader from '../../../components/PageHeader';
import DepartmentService from '../../../services/DepartmentService';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const CreateDepartment = () => {
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [loading, setLoading] = useState(false);

    const onSubmit = async (data) => {
        setLoading(true);
        try {
            const response = await DepartmentService.create({ data });
            if (response?.status === 201) {
                toast.success(response?.data?.message);
                setTimeout(() => {
                    navigate('/departments');
                }, 2000);
            }
        } catch (error) {
            toast.error('An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <AppSidebar />
            <div className="main-content">
                <AppHeader />
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10 col-xl-12">
                            <PageHeader title='Create Department' button_label1="Back"
                             link_to1="/departments" className1="btn btn-primary btn-sm"  />
                            <div className="card p-4">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="row">
                                        {/* Department Name */}
                                        <div className="col-12 col-md-12">
                                            <div className="form-group">
                                                <label className="form-label">Name</label>
                                                <input
                                                    type="text"
                                                    {...register('name', {
                                                        required: 'Name is required',
                                                        minLength: { value: 2, message: 'Name must be at least 2 characters' }
                                                    })}
                                                    className={`form-control ${errors?.name ? 'is-invalid' : ''}`}
                                                />
                                                {errors?.name && <div className="text-danger">{errors?.name?.message}</div>}
                                                <hr />
                                            </div>
                                        </div>
                                        {/* Description Box */}
                                        <div className="col-12 col-md-12">
                                            <div className="form-group">
                                                <label className="form-label">Description</label>
                                                <textarea
                                                    {...register('description', {
                                                        required: 'Description is required',
                                                        minLength: { value: 10, message: 'Description must be at least 10 characters' }
                                                    })}
                                                    className={`form-control ${errors?.description ? 'is-invalid' : ''}`}
                                                    rows="4"
                                                />
                                                {errors?.description && <div className="text-danger">{errors?.description?.message}</div>}
                                                <hr />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='text-end'>
                                    <button type="submit" className="btn btn-primary" disabled={loading}>
                                        {loading ? 'Creating...' : 'Create'}
                                    </button>
                                    </div>
                                </form>
                                <ToastContainer />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateDepartment;